// extracted by mini-css-extract-plugin
export default {"settingsModal":"settings-modal-content_settingsModal__ce-Qo"};